import { render, staticRenderFns } from "./RoomTeamSetting.vue?vue&type=template&id=573db4ef"
import script from "./RoomTeamSetting.vue?vue&type=script&lang=js"
export * from "./RoomTeamSetting.vue?vue&type=script&lang=js"
import style0 from "./RoomTeamSetting.vue?vue&type=style&index=0&id=573db4ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports